// extracted by mini-css-extract-plugin
export default {"container":"style_container__mOOlA","labelCustom":"style_labelCustom__kB2qI"};